var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17.207",
        height: "12.707",
        viewBox: "0 0 17.207 12.707"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Group_4",
            "data-name": "Group 4",
            transform: "translate(-0.5 -0.56)"
          }
        },
        [
          _c("path", {
            attrs: {
              id: "Path_3",
              "data-name": "Path 3",
              d: "M0,.5H16.5",
              transform: "translate(0.5 6.5)",
              fill: "none",
              stroke: _vm.color,
              "stroke-miterlimit": "10",
              "stroke-width": "1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_4",
              "data-name": "Path 4",
              d: "M0,0,6,6,0,12",
              transform: "translate(11 0.913)",
              fill: "none",
              stroke: _vm.color,
              "stroke-miterlimit": "10",
              "stroke-width": "1"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-457f5ec2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457f5ec2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ArrowIcon.vue
// module id = 1535
// module chunks = 116